import { InsurersType } from './insurer-selection/types';

export const transformCurrencyToNumber = (currency: string) => Number(currency.replace('.', '').replace(',', '.'));

export const getInsurerId = (insurers: InsurersType, insurerName: string): number =>
    insurers.find(({ name }) => name === insurerName)?.id || 0;
